module.exports = __webpack_public_path__ + "media/elephant.c91fcbb1.mp3";